export enum FavouriteTransactionEnabledStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  ALL = 'ALL',
}
